<script lang="ts" setup>
import type { DetailsCarItemDetails } from '@autobid/ui/types/components/CarDetails'
import { usePrepareDetailsCarData } from '@autobid/ui/composables/car/usePrepareDetailsCarData'
import { computed } from 'vue'

interface Props {
  details: DetailsCarItemDetails
}

const props = defineProps<Props>()

const { engineTransmissionTurbo } = usePrepareDetailsCarData(
  computed(() => props.details),
)
</script>

<template>
  <tr v-if="engineTransmissionTurbo.display && engineTransmissionTurbo.rows">
    <td>
      <table class="w-full border-collapse">
        <thead>
          <SectionsDetailsPdfElementsHeading as="th">
            {{ engineTransmissionTurbo.title }}
          </SectionsDetailsPdfElementsHeading>
        </thead>
        <tbody>
          <tr>
            <td>
              <SectionsDetailsElementsEngineTransmissionTurboTable
                :rows="engineTransmissionTurbo.rows"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </td>
  </tr>
</template>
